// define application configuration

export default {
  apiRootUrl: process.env.REACT_APP_API_ROOT_URL || 'http://localhost:8000',
  basename: process.env.REACT_APP_BASENAME || '',
  networkStatusTimeout: parseInt(process.env.REACT_APP_NETWORK_STATUS_TIMEOUT, 10) || 2000,
  networkStatusInterval: parseInt(process.env.REACT_APP_NETWORK_STATUS_INTERVAL, 10) || 2000,
  syncInterval: parseInt(process.env.REACT_APP_SYNC_INTERVAL, 10) || 20000,
}
